import React from 'react';
const currencyFields = ['onHandInventory', 'estimated12Months'];

export const NumberInput = ({ field, form }) => {
  const handleChange = (e) => {
    // Quitar todos los caracteres que no sean números o un punto
    const rawValue = e.target.value.replace(/[^0-9.]/g, "");
    
    // Almacenar el valor limpio en Formik
    form.setFieldValue(field.name, rawValue);
  };

  // Crear un valor formateado sólo para la visualización en el input
  const formattedValue = field.value ? parseFloat(field.value).toLocaleString('en-US', { maximumFractionDigits: 20 }) : '';

  // return (
  //   <div className='tw-rounded-lg tw-items-center  tw-text-blue-900 tw-px-2 tw-flex tw-bg-white'>
  //     <div>$</div>
  //        <input 
  //     {...field}
  //     className="tw-px-2 tw-h-12 tw-flex-1"
  //     value={formattedValue}
  //     onChange={handleChange}
  //     onBlur={() => form.setFieldTouched(field.name, true)}
  //   />
  //   </div>
  // );
  return (
    <div className="tw-relative">
      { currencyFields.includes(field.name) && (<div className="tw-absolute tw-font-bold tw-left-3 tw-top-1/2 tw-transform -tw-translate-y-1/2 tw-text-[#003252]">$</div>)}
      <input 
        {...field}  
        className="tw-pl-8 tw-border tw-rounded-lg tw-w-full tw-h-12"
        value={formattedValue}
        onChange={handleChange}
        onBlur={() => form.setFieldTouched(field.name, true)}
      />
    </div>
  );
};
